import { render } from "./ScorerField.vue?vue&type=template&id=07f06361"
import script from "./ScorerField.vue?vue&type=script&lang=js"
export * from "./ScorerField.vue?vue&type=script&lang=js"

import exportComponent from "/home/james/WebstormProjects/pvpconfigui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__